
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/study-abroad-scholarships",
      function () {
        return require("private-next-pages/student-services/study-abroad-scholarships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-services/study-abroad-scholarships"])
      });
    }
  